import {observer} from "mobx-react";
import {FieldSelect, PageContentTitle} from "@kroschke/react-ui";
import {DialogStore} from "../../../store";
import {displayPrinterType} from "../../../api";
import {PrinterTypeDto} from "../../../api/ums";
import {useState} from "react";
import {ModalDialog} from "../../ui";


export interface ConfigrationPrinterOption {
    label: string
    id: string
    type: PrinterTypeDto
}

export interface UserPrinterFormData {
    printer: Map<PrinterTypeDto, string | undefined>
}

interface UserPrinterConfigurationProps {
    options: ConfigrationPrinterOption[]
    data: UserPrinterFormData
    disabled: boolean
    onReset: () => any
    onBlur: () => any
    onChange: (value: UserPrinterFormData) => any
    onSave: () => any
    saving: boolean
    invalid: boolean
    saveDisabled: boolean
    discardDisabled: boolean
}

const UserPrinterConfiguration = observer(function ({
                                                        options,
                                                        data,
                                                        disabled,
                                                        saving,
                                                        onReset,
                                                        onBlur,
                                                        onSave,
                                                        onChange,
                                                        invalid,
                                                        saveDisabled,
                                                        discardDisabled
                                                    }: UserPrinterConfigurationProps) {

    const [cancelDialog] = useState(new DialogStore())
    return <>
        <ModalDialog
            store={cancelDialog}
            actions={[
                {
                    label: "Abbrechen",
                    execute: async function () {
                        cancelDialog.dialogOpen = false
                    },
                    className: 'is-primary is-rounded is-small'
                },
                {
                    label: "Verwerfen",
                    execute: async function () {
                        onReset()
                        cancelDialog.dialogOpen = false
                    },
                    className: 'is-rounded is-small'
                }
            ]}
            title={"Änderungen verwerfen?"}
        >
            Sind Sie sich sicher, dass Sie die Änderungen verwerfen wollen?
        </ModalDialog>

        <PageContentTitle
            actions={[
                {
                    label: 'Speichern',
                    cls: `is-primary ${saving ? 'is-loading' : ''}`,
                    disabled: saveDisabled,
                    action: async () => {
                        await onSave()
                    }
                },
                {
                    label: 'Verwerfen',
                    cls: 'is-primary is-outlined',
                    disabled: discardDisabled,
                    action: () => {
                        cancelDialog.dialogOpen = true
                    }
                },
            ]}
        >Standarddrucker festlegen</PageContentTitle>
        <div style={{overflow: 'visible', padding: '1em'}}>

            {Object.keys(PrinterTypeDto)
                .map(e => e as PrinterTypeDto)
                .map((printerType => {
                    return <div className={"columns"} key={printerType}>
                        <div className={"column is-one-fifth"}>
                            <label
                                className={`label`}
                            >{displayPrinterType(printerType)}</label>
                        </div>
                        <div className={"column"}>
                            <FieldSelect
                                disabled={disabled}
                                label={`${(printerType)} Drucker auswählen`}
                                options={options.filter(p => p.type === printerType)
                                    .map(p => ({label: p.label, value: p.id}))}
                                value={data.printer.get(printerType)}
                                onBlur={() => onBlur()}
                                invalid={invalid}
                                help={invalid ? 'Konfiguration ungültig' : ''}
                                onChange={e => {
                                    data.printer.set(printerType, e || undefined)
                                    onChange({
                                        printer: data.printer
                                    })
                                }}
                            />
                        </div>
                    </div>
                }))}
        </div>
    </>
})

export {
    UserPrinterConfiguration
}
